
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 .5C5.24.5 0 5.452 0 12.14c0 3.498 1.434 6.521 3.768 8.61a.958.958 0 01.323.684l.065 2.134a.96.96 0 001.347.85l2.382-1.052a.958.958 0 01.641-.047c1.095.3 2.26.461 3.474.461 6.76 0 12-4.952 12-11.64C24 5.452 18.76.5 12 .5z","fill":"url(#paint0_radial_70_314)"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.793 15.544l3.525-5.592a1.8 1.8 0 012.602-.48l2.804 2.102a.72.72 0 00.867-.002l3.787-2.874c.505-.384 1.165.221.827.758l-3.525 5.593a1.8 1.8 0 01-2.603.48l-2.804-2.103a.72.72 0 00-.867.002l-3.787 2.874c-.505.384-1.165-.221-.826-.758z","fill":"#fff"}}),_c('defs',[_c('radialGradient',{attrs:{"id":"paint0_radial_70_314","cx":"0","cy":"0","r":"1","gradientUnits":"userSpaceOnUse","gradientTransform":"matrix(26.1504 0 0 26.1503 4.62 24.372)"}},[_c('stop',{attrs:{"stop-color":"#09F"}}),_c('stop',{attrs:{"offset":".61","stop-color":"#A033FF"}}),_c('stop',{attrs:{"offset":".935","stop-color":"#FF5280"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FF7061"}})])])])
          )
        }
      }
    